import{registerElementSafely as e}from"@cds/core/internal";import{CdsInternalPanelTagName as r,CdsInternalPanel as m}from"./panel.element.js";e(r,m);
